import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import ApiErrorView from './ApiErrorView';
import { ERROR_SOURCE } from './parseApiError';

class ErrorGuard extends Component {
  constructor(props) {
    super(props);
    this.state = { unhandledError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ unhandledError: error });
    Sentry.captureException(error);
  }

  render() {
    const error = this.state.unhandledError;
    if (!error) {
      return this.props.children;
    }

    const parsed = {
      hasError: true,
      status: 0,
      source: ERROR_SOURCE.CLIENT,
      sourceLabel: 'Galileo',
      title: 'Something went wrong',
      message: 'Please reload the page and try again. If it keeps happening, email mta-support@hearst.com.',
      hint: '',
      rawMessage: error.toString(),
      details: [],
      toastMessage: 'Something went wrong. Please reload the page and try again.',
      isPageBlocking: true
    };

    return <ApiErrorView parsed={parsed} entity="page" variant="page" />;
  }
}

export default ErrorGuard;
